import React, { Fragment } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';
import { SecureRoute, Security } from '@okta/okta-react';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import HomeDashboard from './components/home-dashboard/HomeDashboard';
import Login from './components/login/Login';
import oktaConfig from './oktaConfig.js';

const oktaAuth = new OktaAuth(oktaConfig);
const SecurityWrapper = ({ oktaAuth }) => {
  const history = useHistory();

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.push(originalUri || '/businesses');
  };

  const onAuthRequired = () => {
    window.location.replace('/login');
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
      onAuthRequired={onAuthRequired}
    >
      <Switch>
        <Route path="/login">
          <Login oktaAuth={oktaAuth} />
        </Route>
        <SecureRoute path="*" component={HomeDashboard} />
        <SecureRoute path="/" component={HomeDashboard} exact />
      </Switch>
    </Security>
  );
};

const Routes = () => {
  return (
    <Fragment>
      <Router>
        <SecurityWrapper oktaAuth={oktaAuth} />
      </Router>
    </Fragment>
  );
};

export default Routes;
